/**
 * Notification Bell Button
 * 
 * Bell icon button that opens the notification sheet panel.
 * Shows unread count badge when there are unread notifications.
 */

import { Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNotifications } from "@/features/notifications/use-notifications";
import { cn } from "@/lib/utils";

export const NotificationBellButton = () => {
  const { unreadCount, openSheet } = useNotifications();
  
  return (
    <Button
      variant="outline"
      size="icon"
      onClick={openSheet}
      className="relative"
      aria-label={`Notifications${unreadCount > 0 ? ` (${unreadCount} unread)` : ""}`}
    >
      <Bell className="size-4" />
      {unreadCount > 0 && (
        <span
          className={cn(
            "absolute -right-1 -top-1 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white",
            unreadCount > 99 && "text-[8px]"
          )}
        >
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
    </Button>
  );
};

